import type { ElementType, ReactElement } from "react";

import { cx, styled } from "simplydo/react/styled";

import { StyledRow } from "./Table.styles";
import type { TableRowProps } from "./Table.types";

const TableRowComponent = (props: TableRowProps): ReactElement => {
  const {
    as,
    active,
    disabled,
    error,
    negative,
    positive,
    warning,
    textAlign,
    verticalAlign,
    className,
    style,
    children,
    onClick,
    ...rest
  } = props;
  const Component = (as || "tr") as ElementType;
  return (
    <StyledRow
      as={Component}
      className={cx(
        className,
        active && "is-active",
        disabled && "is-disabled",
        error && "is-error",
        negative && "is-negative",
        positive && "is-positive",
        warning && "is-warning",
      )}
      style={style}
      $textAlign={textAlign}
      $verticalAlign={verticalAlign}
      onClick={onClick}
      {...(rest as object)}
    >
      {children}
    </StyledRow>
  );
};

export const TableRow = styled(TableRowComponent)``;
